









import Vue from 'vue'
import Component from 'vue-class-component'
import { Action } from 'vuex-class'

import UserInterface2FolderDataTable from '../../../../../html-components-type-1-basic/basic-type-4-user-interface/user-interface-2-folder-data-table.vue'

import {
  DataTableFile,
  itemTypeAccount
} from '../../../../../html-components-type-1-basic/basic-type-4-user-interface/service-for-data-structures/data-structures-1-file-system-data-structure'

import { DigitalCurrencyAccount } from '../../../../../../../../../../../service-for-game-codebase/game-codebase-type-1-app/app-type-2-digital-currency-account/digital-currency-account-type-2-data-structures/data-structures-type-1-service-data-structure/service-data-structure-1'
import { LIST_TYPE_DIGITAL_CURRENCY_ALTERNATIVE } from '../../../../../../../../../../../service-for-game-codebase/game-codebase-type-1-app/app-type-2-digital-currency-account/digital-currency-account-type-1-algorithms/algorithms-type-26-get-digital-currency-account-list/get-digital-currency-account-list-1'


const namespace = 'digitalCurrency'

@Component({
  components: {
    UserInterface2FolderDataTable
  }
})
class DigitalCurrencyAlternativeResourceItem1FindDigitalCurrencyAlternatives extends Vue {

  @Action('getDigitalCurrencyAccountList', { namespace }) getDigitalCurrencyAccountList?: any

  initialFile: DataTableFile = new DataTableFile()

  async mounted () {
    await this.initializeInitialFile()
  }

  async initializeInitialFile () {
    const digitalCurrencyAccountList: DigitalCurrencyAccount[] = await this.getDigitalCurrencyAccountList({
      listType: LIST_TYPE_DIGITAL_CURRENCY_ALTERNATIVE
    })

    const digitalCurrencyAccountMap = digitalCurrencyAccountList.reduce((map: any, obj: any, index: number) => (map[obj.accountId] = digitalCurrencyAccountList[index], map), {})

    for (let digitalCurrencyAccountId in digitalCurrencyAccountMap) {
      if (!digitalCurrencyAccountMap.hasOwnProperty(digitalCurrencyAccountId)) {
        continue
      }
      const digitalCurrencyAccount = digitalCurrencyAccountMap[digitalCurrencyAccountId]
      const accountFile = new DataTableFile()
      accountFile.itemId = digitalCurrencyAccount.accountId
      accountFile.itemName = digitalCurrencyAccount.accountName
      accountFile.itemIconImageUrl = digitalCurrencyAccount.accountProfilePictureUrl
      accountFile.itemType = itemTypeAccount
      digitalCurrencyAccountMap[digitalCurrencyAccountId] = accountFile
    }

    this.initialFile.fileVariableTable = digitalCurrencyAccountMap

    return this.initialFile
  }
}

export default DigitalCurrencyAlternativeResourceItem1FindDigitalCurrencyAlternatives

